import { render, staticRenderFns } from "./MassCancellationOfTripsView.vue?vue&type=template&id=1670c7b5"
import script from "./MassCancellationOfTripsView.vue?vue&type=script&lang=ts"
export * from "./MassCancellationOfTripsView.vue?vue&type=script&lang=ts"
import style0 from "./MassCancellationOfTripsView.vue?vue&type=style&index=0&id=1670c7b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports